export const PRODUCT_NAME = 'DIESEL DIAGNOSTIC PRO™'
export const OFFER_ANCHOR = '#offer'
export const CHECKOUT_URL = 'https://diesel-diagnostic-pro.impultienda.ar/checkout'
export const PRODUCT_IMG =
  'https://cdn.magicpatterns.com/uploads/1XkfqoE2EVeG35Qxr5jRdY/Diseno-sin-titulo-4.webp'
